var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_2723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2002 35.8707C52.2002 36.5138 51.8571 37.108 51.3002 37.4296L29.7002 49.9004C29.1433 50.2219 28.4571 50.2219 27.9002 49.9004C27.3433 49.5788 27.0002 48.9846 27.0002 48.3415L27.0002 23.4C27.0002 22.7569 27.3433 22.1627 27.9002 21.8411C28.4571 21.5196 29.1433 21.5196 29.7002 21.8411L51.3002 34.3119C51.8571 34.6334 52.2002 35.2277 52.2002 35.8707ZM30.6002 26.5177L30.6002 45.2238L46.8002 35.8707L30.6002 26.5177Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_2723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e24093a5344acf1ed6acd42397aa41bc.svg";
export { ForwardRef as ReactComponent };